<template>
    <div 
        v-if="pergunta.datahoradel==null"
        class="campo"
        :class="{ 'campo-not-expanded': !expanded, 'not-first': index, 'invalid': !getValidade() && expanded }"
    >
        <div class="not-expanded" v-if="!expanded">
            <div class="p-handle">
                <svg class="svg-icons">
                    <use :xlink:href="require('@/assets/img/icons/drag.svg')+'#layer'"></use>
                </svg>
            </div>
            <div 
                class="nome"
                :class="{'invalid': !getValidade()}" 
                tabindex="0"
                @focus="expand()"
            >
                {{ (pergunta.descricao!= undefined&&pergunta.descricao.trim()!='')? cutString(pergunta.descricao, 70) : $t('pergunta-sem-titulo')}}
            </div>
        </div>
        <div class="expanded" ref="expanded" v-else tabindex="0">
            <div class="nome">
                <span>{{ $t('titulo-da-pergunta') }}</span>
                <svg  class="svg-icons minimize" @click="expanded = false">
                    <use :xlink:href="require('@/assets/img/icons/window-minimize.svg')+'#layer'"></use>
                </svg>
            </div>
            <div class="campos">
                <div class="titulo-campo">
                    <v-textarea
                        ref="titulo-campo"
                        v-model="pergunta.descricao"
                        :maxlength="150"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!pergunta.descricao"
                        :placeholder="'titulo-campo-placeholder'"
                        :rows="2"
                        :maxRows="3"
                        :disableTransform="true"
                        :onKeyUp="emitUpdates"
                        :focusEvt="() => expanded = true"
                    />
                </div>
                <div class="campo-tipo">
                    <vss-select
                        ref="tipoSelect"
                        @input="updateTipo"
                        v-model="tipo"
                        :options="tipos"
                        no-clearfix
                        placeholder="tipo-do-campo"
                        title="tipo-do-campo"
                        :displayFlex="false"
                        :mlLabelsTitle="true"
                    >
                        <template #option="{ option }">
                            <svg  class="svg-icons">
                                <use :xlink:href="require('@/assets/img/icons/' + option.svg + '.svg')+'#layer'"></use>
                            </svg>
                            {{ $t(option.label) }}
                        </template>
                    </vss-select>
                </div>
                <div 
                    class="respostas" 
                    v-if="['TEXT', 'MULTITEXT', 'INTEGER', 'DECIMAL', 'PERCENT'].indexOf(this.pergunta.gruporespostas[0].tipo) > -1"
                >
                    <input 
                        @keyup="emitUpdates()" 
                        ref="resposta" 
                        @focus="expanded = true" 
                        v-model="pergunta.gruporespostas[0].placeholder" 
                        type="text" 
                        v-bind:placeholder="$t('resposta-campo-placeholder-' + this.pergunta.gruporespostas[0].tipo)"
                        maxlength="255"
                    />
                </div>
                <div 
                    class="respostas" 
                    v-if="['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].indexOf(pergunta.gruporespostas[0].tipo) > -1"
                >
                    <div 
                        v-for="(r, i) in pergunta.gruporespostas[0].respostas" :key="i" 
                        class="resposta"
                    >
                        <div v-if="!r.datahoradel">
                            <fSwitch :disabled="true" class="campo-resposta" v-if="pergunta.gruporespostas[0].tipo == 'SWITCH'"/>
                            <b-icon class="resposta-icon" icon="checkbox-blank-outline" v-if="pergunta.gruporespostas[0].tipo == 'CHECKBOX'"/>
                            <b-icon class="resposta-icon" icon="radiobox-blank" v-if="pergunta.gruporespostas[0].tipo == 'RADIO'"/>
                            <input 
                                class="check-input" 
                                @keyup="emitUpdates()" 
                                v-model="r.descricao" 
                                @focus="expanded = true" 
                                :ref="`input_${index}_${i}`" 
                                type="text" :placeholder="$t('opcao-campo-placeholder') + ' ' + (i + 1)" 
                                maxlength="255" 
                                required 
                            />
                            <!-- <svg class="svg-icons" @click="excluirResposta(r)" @focus="expanded = true" >
                                <use :xlink:href="require('@/assets/img/icons/delete.svg')+'#layer'"></use>
                            </svg> -->
                        </div>
                    </div>
                    <div class="resposta-add">
                        <fSwitch :disabled="true" class="campo-resposta" v-if="pergunta.gruporespostas[0].tipo == 'SWITCH'"/>
                        <b-icon class="resposta-icon" icon="checkbox-blank-outline" v-if="pergunta.gruporespostas[0].tipo == 'CHECKBOX'"/>
                        <b-icon class="resposta-icon" icon="radiobox-blank" v-if="pergunta.gruporespostas[0].tipo == 'RADIO'"/>
                        <input 
                            class="check-input" 
                            @keyup="emitUpdates()" 
                            ref="respostaField" 
                            @focus="addField()" 
                            type="text" 
                            v-bind:placeholder="$t('opcao-campo-placeholder')" 
                            maxlength="0"
                        />
                    </div>
                </div>
            </div>
            <div class="opcoes" >
                <!-- <div class="buttons">
                    <div>
                        <svg class="svg-icons" @click="copiarPergunta()" @focus="expanded = true">
                            <use :xlink:href="require('@/assets/img/icons/content-copy.svg')+'#layer'"></use>
                        </svg>
                    </div>
                    <div>
                        <svg class="svg-icons" @click="excluirPerguntaModal()" @focus="expanded = true">
                            <use :xlink:href="require('@/assets/img/icons/delete.svg')+'#layer'"></use>
                        </svg>
                    </div>
                </div> -->
                <!-- <fSwitch 
                    :value="`pergunta_${this.index}`" 
                    :focus="() => expanded = true" 
                    :text="$t('campo-obrigatorio')" 
                    :checked="pergunta.obrigaresposta" 
                    :onChange="changeObriga"
                /> -->
            </div>
        </div>
    </div>
</template>

<script>
import fSwitch from "@/components/shared/form/Switch.vue";
import SelectBox from "@/components/shared/form/SelectBox.vue";

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
*/
export default {
    components: {
        fSwitch,
        SelectBox
    },
    props: {
        pergunta: {
            default: {}
        },
        expandir: {
            default: false
        },
        index: Number,
        canSelectTipo: false
    },
    data() {
        return {
            texttypemenu: false,
            expanded: this.expandir,
            tipo: null,

            tipos: [
                {
                    index: 0,
                    class: "fas fa-align-right",
                    svg: "text-short",
                    desc: "Área de Texto Curto",
                    label: 'area-texto-curto',
                    type: "TEXT"
                },
                {
                    index: 1,
                    class: "fas fa-align-justify",
                    svg: "text-subject",
                    desc: "Área de Texto Longo",
                    label: 'area-texto-longo',
                    type: "MULTITEXT"
                },
                {
                    index: 2,
                    class: "fas fa-list-ol",
                    svg: "text-short",
                    desc: "Campo de Número",
                    label: 'campo-numero',
                    type: "INTEGER"
                },
                {
                    index: 3,
                    class: "fas fa-dollar-sign",
                    svg: "currency-usd",
                    desc: "Campo de Moeda",
                    label: 'campo-moeda',
                    type: "DECIMAL"
                },
                {
                    index: 4,
                    class: "fas fa-percent",
                    svg: "percent",
                    desc: "Campo de Porcentagem",
                    label: 'campo-porcentagem',
                    type: "PERCENT"
                },
                // {
                //     index: 5,
                //     class: 'fas fa-list-ol',
                //     svg: 'text-short',
                //     desc: 'Numeração Automática',
                // },
                {
                    index: 6,
                    class: "fas fa-list-ol",
                    svg: "text-short",
                    desc: "Disjuntor",
                    label: 'disjuntor',
                    type: "SWITCH"
                },
                // {
                //     index: 7,
                //     class: 'fas fa-stop',
                //     svg: 'checkbox-blank',
                //     desc: 'Caixa de Solução',
                //     type: 'SWITCH'
                // },
                {
                    index: 8,
                    class: "fas fa-calendar",
                    svg: "calendar-clock",
                    desc: "Campo de Data e Hora",
                    label: 'campo-data-hora',
                    type: "DATETIME"
                },
                {
                    index: 9,
                    class: "far fa-calendar-alt",
                    svg: "calendar",
                    desc: "Calendário",
                    label: 'calendario',
                    type: "DATE"
                },
                {
                    index: 10,
                    class: "fas fa-dot-circle",
                    svg: "radiobox-marked",
                    desc: "Multipla Escolha",
                    label: 'multipla-escolha',
                    type: "RADIO"
                },
                {
                    index: 11,
                    class: "fas fa-check-square",
                    svg: "checkbox-marked",
                    desc: "Lista de Opções",
                    label: 'lista-opcoes',
                    type: "CHECKBOX"
                },
                {
                    index: 12,
                    class: "fas fa-chevron-circle-down",
                    svg: "menu-down",
                    desc: "Combo box",
                    label: 'combo-box',
                    type: "COMBOBOX"
                }
            ],
            tipostextnum: 0,
            selectedIndex: 0,
            // ConfiguraCampos.vue
            confCampos: this.$parent.$parent,
            tipoSelectHasListener: false,
        };
    },
    created() {
        this.tipostextnum = this.tipos.length;
        let descs = this.tipos.filter(
            t =>
                this.pergunta.gruporespostas[0] &&
                t.type == this.pergunta.gruporespostas[0].tipo
        )[0];

        this.tipo = this.pergunta.gruporespostas[0]
            ? {
                id: this.pergunta.gruporespostas[0].tipo,
                desc: descs ? descs.desc : "",
                label: descs ? descs.label : '',
                type: this.pergunta.gruporespostas[0].tipo
            }
            : {
                svg: "text-short",
                desc: "Área de Texto Curto",
                label: 'area-text-curto',
                type: "TEXT"
            };
    },
    methods: {
        openTextOptions() {
            this.texttypemenu = !this.texttypemenu;
        },
        setSelectedItem(index) {
            this.selectedIndex = index;
        },
        onDrop: function(dropResult) {
            this.items = applyDrag(this.items, dropResult);
        },
        updateTipo(tipo) {
            if (!this.pergunta.gruporespostas[0]) this.pergunta.gruporespostas.push({});
            if (tipo) {
                this.pergunta.gruporespostas[0].tipo = tipo.type;
                this.tipo.desc = tipo.desc;
                this.tipo.id = tipo.type;
                this.tipo.type = tipo.type;
                this.tipo.label = tipo.label;
            }
        },
        addField() {
            this.expanded = true;
            this.pergunta.gruporespostas[0].respostas.push({});
            this.emitUpdates();
            setTimeout(() => {
                let i = this.pergunta.gruporespostas[0].respostas.length - 1;
                this.$refs[`input_${this.index}_${i}`][0].focus();
            }, 100);
        },
        copiarPergunta() {
            this.confCampos.$emit("copiar-pergunta", this.index);
        },
        excluirPergunta() {
            this.confCampos.$emit("excluir-pergunta", this.index);
        },
        excluirPerguntaModal () {
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { 
                    n: this.pergunta.descricao 
                        ? this.pergunta.descricao : 
                        this.$t('pergunta-sem-titulo')
                }),
                onConfirm: this.excluirPergunta
            });
        },
        excluirResposta(elem){
            elem.datahoradel = new Date();
            let del = this.pergunta.gruporespostas[0].respostas.indexOf(elem);
            if (del >= 0){
                if (elem.datahorainc){ // reposta já no banco nao pode deletar
                    this.pergunta.gruporespostas[0].respostas.splice(del,1,elem);
                } else { // resposta nao esta no banco pode remover do array
                    this.pergunta.gruporespostas[0].respostas.splice(del,1);
                }
            }
        },
        changeObriga(e) {
            this.pergunta.obrigaresposta = e.target.checked ? 1 : 0;
            this.emitUpdates();
        },
        expand() {
            this.expanded = true;
            this.$nextTick(() => this.$refs['titulo-campo'].onFocus() );
        },
        emitUpdates() {
            this.confCampos.$emit('update-pergunta', this.pergunta, this.index);
        },
        getValidade () {
            let p = this.pergunta;
            let valid = true;

            if (p.descricao == undefined || p.descricao == null || p.descricao.trim() == '') { valid = false; }
            
            p.gruporespostas.forEach(gr => {
                if (['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].indexOf(gr.tipo) > -1) {
                    if (gr.respostas.length == 0) {
                        valid = false;
                    } else {
                        gr.respostas.forEach(r => {
                        if (r.descricao == undefined || r.descricao == null || r.descricao.trim() == '') {
                            valid = false;
                        }
                        });
                    }
                }
            });
            return valid;
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return option.desc;
            }
        }
    }
};
</script>

<style lang="scss" scoped >
.campo {
    position: relative;
    padding: 15px;
    background: $sovis-white;
    // box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 10px;
    border: 1px solid $table-border;

    &:not(:first-child) {
        margin: 10px 0;
    }

    &.campo-not-expanded {
        box-sizing: border-box;
        box-shadow: none;
        margin-bottom: 0;
        margin-top: 0;
        padding: 0;
    }

    &.invalid {
        border: 1px solid $red-alert;
    }

    .not-expanded:focus,
    .expanded:focus,
    .not-expanded:focus,
    .expanded:focus {
        outline: none;
    }

    .not-expanded {
        display: flex;
        align-items: center;
        min-height: 40px;
        padding-right: 5px;

        .p-handle {
            display: flex;
            align-items: center;
            width: 20px;
            height: 100%;
            margin: 0 5px;
            cursor: move;

            svg {
                transform: rotate(90deg);
            }
        } 

        &>div {
            display: inline-block;

            > h4 {
                cursor: pointer;
            }
        }

        .nome {
            display: inline-flex;
            align-items: center;
            width: 100%;
            height: 100%;
            font-size: 14px;
            color: $primary-color;
            font-weight: 600;
            text-transform: uppercase;
            cursor: pointer;

            &.invalid {
                color: $red-alert;
            }
        }
    } 
    
    .expanded {
        .nome {
            display: flex;
            justify-content: space-between;
            color: $primary-color;
            font-weight: 600;
            margin-bottom: 5px;

            .minimize {
                cursor: pointer;
            }
        }
    }

    .opcoes {
        margin-top: 15px;
        padding: 15px 10px 5px 10px;
        border-top: 0.5px solid $table-border;
        flex: 0 1 auto;
        display: flex;
        justify-content: flex-start;

        > .buttons {
            border-right: 0.5px solid $light-gray-color;
            display: flex;

            &:not(:last-child){
                margin-bottom: 0 !important;
            }

            > div {
                height: 30px;
                width: 30px;
                margin-right: 20px;

                svg {
                    cursor: pointer;
                    fill: $darker-gray-color;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .campos {
        flex: 1 1 auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        > .titulo-campo {
            width: 67%;
            margin-right: 3%;
        }

        > .campo-tipo {
            width: 30%;

            .dropdown-toggle {
                height: 35px;
                // padding: 0;
            }
        }

        > .respostas {
            width: 100%;
            margin-top: 10px;

            input {
                outline: none;
                border: none;
                width: 67%;
                padding-bottom: 0;
                padding-left: 5px;
                font-weight: 200;
                color: $darker-gray-color;
                border-bottom: 1px dotted $light-gray-color;

                &:focus {
                    border-bottom: 1px solid $primary-color;
                }

                &.check-input {
                    width: calc(64%) !important;
                }
            }

            .resposta, .resposta-add {
                display: flex;
                align-items: center;

                input {
                    outline: none;
                    border: none;
                    width: 67%;
                    padding-bottom: 0;
                    padding-left: 5px;
                    font-weight: 200;
                    color: $darker-gray-color;
                    border-bottom: 1px dotted $light-gray-color;

                    &:focus {
                        border-bottom: 1px solid $primary-color;
                    }

                    &.check-input {
                        width: calc(64%) !important;
                    }

                    &[type=checkbox], &[type=radio] {
                        opacity: 0;
                    }
                }

                svg {
                    cursor: pointer;
                }

                .resposta-icon{
                    color: $text-color;
                }

                .campo-resposta {
                    display: inline-block;
                }

                .check-box {
                    .checkmark {
                        position: inherit;
                        display: inline-flex;
                        top: 0;
                        right: 0;
                        height: 16px;
                        width: 16px;
                        border: 2px solid $primary-color-hover;
                        margin-top: 5px;
                        margin-right: 10px;
                        border-radius: 3px;
                    }
                }

                .radio-box .checkmark {
                    top: -5px;
                }

                &:not(:first-child) {
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
